declare global {
  interface String {
    replaceAll(find: string, value: string): string;
  }
}

export { ReservationDetailComponent } from './lib/components/reservation-detail/reservation-detail.component';
export { ReservationDetailModalData } from './lib/components/reservation-detail/reservation-detail-modal.data';
export { NewReservationDialogComponent } from './lib/components/new-reservation-dialog/new-reservation-dialog.component';
export {
  NewReservationCreatedEventResult,
  NewReservationCreateDialogData,
  NewReservationDialogData,
  NewReservationDialogMode,
  NewReservationDialogResult,
  NewReservationDialogUiState,
  NewReservationExistingDialogData,
} from './lib/components/new-reservation-dialog/new-reservation-dialog.data';
export {
  mapReservationDetailToNewDialogData,
  NewReservationDialogOpenConfig,
  ReservationDialogOpenConfig,
  ReservationDialogOpener,
  ReservationDialogResult,
} from './lib/services/reservation-dialog-opener.service';
